import { _axios } from "../../../Utils/Axios/axios";

export const getSubjectOfUserLesson_Service = async (
  userToken: string,
  lesson_id: string
) => {
  return _axios.post(
    "/subjects_of_lesson_of_user",
    {
      lesson_id,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
